import { ImageType } from '@thesavingsgroup/enums/ImageType';
import find from 'lodash/find';

import { DashboardVehicle } from '../types/DashboardVehicle';

export const getVehicleDefaultImage = (
  vehicle: DashboardVehicle,
): string | undefined =>
  find(vehicle.images, (img): boolean => img.type === ImageType.DEFAULT)?.url;
